export default __webpack_public_path__ + "static/media/question.14fdc074.svg";